import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, I18nModule, provideConfig, UrlModule } from "@spartacus/core";
import { IconModule, MediaModule, SpinnerModule } from "@spartacus/storefront";
import { translationsEn } from "@spartacus/assets";
import { productTranslationChunksConfig } from "../../shared/components/bundle-slide/bundle-slide.module";
import { GenDealerAcquisitionProductsComponent } from './dealer-acquisition-products.component';
import { GenDealerAcquisitionProductComponent } from './dealer-acquisition-product/dealer-acquisition-product.component';
import { GenAddToCartModule } from '../cart/product-add-to-cart/product-add-to-cart.module';
import { GenInfoPriceWrapperComponent } from '../../shared/components/info-price-wrapper/info-price-wrapper.component';
import { RouterModule } from '@angular/router';
import { GenInfoMessageComponent } from '../../shared/components/info-message/info-message.component';

@NgModule({
  declarations: [
    GenDealerAcquisitionProductComponent,
    GenDealerAcquisitionProductsComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    MediaModule,
    RouterModule,
    UrlModule,
    SpinnerModule,
    ConfigModule,
    GenInfoMessageComponent,
    GenAddToCartModule,
    GenInfoPriceWrapperComponent,
  ],
  exports: [
    GenDealerAcquisitionProductComponent,
    GenDealerAcquisitionProductsComponent,
  ],
  providers: [
    provideConfig({
      i18n: {
        resources: {
          en: translationsEn
        },
        chunks: productTranslationChunksConfig
      }
    })
  ]
})
export class GenDealerAcquisitionProductsModule { }
